import { createSelector } from "reselect";
import startCase from "lodash/startCase";
import { Employee } from "../interfaces/User";
import { RootState } from "../store";

// selectors
export const employeeFullNameSelector = (
  serviceProvider = { firstName: "", lastName: "" }
): string => {
  const { firstName, lastName } = serviceProvider;
  return `${startCase(firstName)} ${startCase(lastName)}`;
};

export const employeesSelector = (state: RootState): Employee[] =>
  state.resources.resourceCentreEmployees;

export const activeEmployees = createSelector(employeesSelector, (employees: Employee[]) =>
  employees.filter(({ active }) => active)
);

export const employeesSortedSelector = createSelector(activeEmployees, (employees: Employee[]) =>
  employees.sort((a, b) =>
    `${a.firstName || ""}${a.lastName || ""}`.toLowerCase() >
    `${b.firstName || ""}${b.lastName || ""}`.toLowerCase()
      ? 1
      : -1
  )
);
